import { render, staticRenderFns } from "./activity-baseinfo.vue?vue&type=template&id=58c4bceb&scoped=true&"
import script from "./activity-baseinfo.vue?vue&type=script&lang=js&"
export * from "./activity-baseinfo.vue?vue&type=script&lang=js&"
import style0 from "./activity-baseinfo.vue?vue&type=style&index=0&id=58c4bceb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58c4bceb",
  null
  
)

export default component.exports